export default "__VITE_ASSET__DCPnBxWB__"